import React from 'react';

import { type CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../../config-items/config-items';
import { Icon } from '../../assets/icons/translate';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { languageMessages, translateToMessages } from '../../translations/messages';
import {
	getSortedSupportedTranslationLanguages,
	isRefinementSupport,
} from '../../translations/utils';

const supportedTranslationLanguages = getSortedSupportedTranslationLanguages();

const translationConfigItemsArr = supportedTranslationLanguages
	.map((language) => {
		const lang = languageMessages[language];
		if (!lang) {
			return false;
		}
		const configItem: EditorPluginAIConfigItem = {
			key: `Translate to ${language}` as CONFIG_ITEM_KEYS,
			title: translateToMessages[`${language}Title`],
			description: translateToMessages[`${language}Description`],
			icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
			showInRefineDropdown: isRefinementSupport(language),
			nestingConfig: {
				parentTitle: languageMessages.nestingParentTitlePostGA,
				shortTitle: lang,
			},
			intentSchemaId: 'translate_intent_schema.json',
			lang: lang.defaultMessage,
			actions: {
				empty: [
					createInsertBelow({ appearance: 'secondary' }),
					createReplace({ appearance: 'primary' }),
				],
				selection: [
					createInsertBelow({ appearance: 'secondary' }),
					createReplace({ appearance: 'primary' }),
				],
			},
		};

		return [language, configItem];
	})
	.filter(Boolean) as [string, EditorPluginAIConfigItem][];

export const translationConfigItemsMap: {
	[k: string]: EditorPluginAIConfigItem;
} = Object.fromEntries(translationConfigItemsArr.filter(Boolean));

export const translationConfigItems: EditorPluginAIConfigItem[] =
	Object.values(translationConfigItemsMap);

export const translationConfigItemWithOptions: EditorPluginAIConfigItemWithOptions[] =
	translationConfigItems.map((config) => ({
		config,
		triggers: { empty: { docMinSize: 1 }, selection: true },
	}));
